import React from 'react';
import { Modal, Form, Input, Select, message } from 'antd';
import axios from 'axios';
import { API_BASE_URL } from '../constants/api';

const CategoryCreateModal = ({ open, onCancel, onOk, onSuccess, form, categories, editingCategory }) => {
  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      
      if (editingCategory && editingCategory.id) {
        // Update existing category
        const response = await axios.put(`${API_BASE_URL}Category/Update/${editingCategory.id}`, values);
        if (response.data.code === 0) {
          message.success('تم تحديث الفئة بنجاح');
          onSuccess();
        } else {
          message.error(response.data.message || 'فشل في تحديث الفئة');
        }
      } else {
        // Create new category
        const response = await axios.post(`${API_BASE_URL}Category/Create`, values);
        if (response.data.code === 0) {
          message.success('تم إنشاء الفئة بنجاح');
          onSuccess();
        } else {
          message.error(response.data.message || 'فشل في إنشاء الفئة');
        }
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'خطأ في حفظ الفئة';
      message.error(errorMessage);
    }
  };

  return (
    <Modal
      title={editingCategory ? 'تعديل الفئة' : 'إضافة فئة'}
      open={open}
      onOk={handleOk}
      onCancel={onCancel}
      width="90%"
      style={{ maxWidth: 600 }}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="name"
          label="الاسم"
          rules={[{ required: true, message: 'يرجى إدخال اسم الفئة!' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="baseCategoryId"
          label="الفئة الأساسية"
        >
          <Select
            placeholder="اختر الفئة الأساسية"
            allowClear
          >
            {categories.map(cat => (
              <Select.Option key={cat.id} value={cat.id}>
                {cat.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CategoryCreateModal;
